<template>
  <div class="diagnocat-multiupload"
       v-if="studyIdForMultiupload">
    <div>{{ $t('files_being_uploaded') }}</div>
    <ProgressBar :max="multiUploadFilesTotal"
                 :value="multiUploadFilesUploaded"/>
  </div>
</template>

<script setup>
import { useStore } from "vuex"
import { computed } from "vue"
import ProgressBar from "@/components/parts/general/ProgressBar.vue"

const store = useStore()

const studyIdForMultiupload = computed(() => store.state.study.studyIdForMultiupload)
const multiUploadFilesTotal = computed(() => store.state.study.multiUploadFilesTotal)
const multiUploadFilesUploaded = computed(() => store.state.study.multiUploadFilesUploaded)

</script>

<style scoped lang="scss">
.diagnocat-multiupload {
  max-width: 320px;
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 6;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.15);
  border-radius: 10px;
  padding: 15px;
  background: #fff;
}
</style>
